<template>
  <div class="locale-content">
    <div class="bloc">
      <div class="logo-container">
        <div class="cannect-logo">
          <img
            src="@/assets/CAnnectLogo.svg"
            alt="CAnnect"
          />
        </div>
      </div>
      <div class="title">
        <h1>Conditions Générales d’Utilisation de CAnnect</h1>
      </div>
      <h2>Bienvenue sur le Réseau Social d’Entreprise CAnnect.</h2>
      <div class="welcome-text">
        <p>
          Le réseau social d’entreprise (ci-après « <strong>CAnnect</strong> ») de CA
          Indosuez (ci-après « <strong>CAI</strong> ») permet à ses Utilisateurs
          d’échanger, de partager de l’information et de développer leur réseau
          professionnel au niveau du Groupe Indosuez au sein duquel sont regroupées
          des filiales et/ou succursales de CAI (ci-après individuellement «<strong>l’Entité Indosuez</strong>» ou
          collectivement «<strong>les Entités Indosuez</strong>») selon leurs centres d’intérêts
          dans des communautés thématiques.
        </p>
        <p>
          Les présentes conditions générales d’utilisation (ci-après les «<strong>Conditions Générales d’Utilisation</strong>») ont
          pour objet de déterminer les modalités et conditions d’utilisation de
          CAnnect, ainsi que de définir les droits et obligations des Utilisateurs
          dans ce cadre.
        </p>
        <p>
          Lors de sa première connexion sur Cannect, l’Utilisateur doit prendre
          connaissance et accepter les présentes Conditions Générales d’Utilisation �
          l’aide d’une case à cocher. Cette acceptation constitue la manifestation de
          son consentement univoque et éclairé.
        </p>
        <p>
          CAI se réserve le droit de modifier les Conditions Générales d’Utilisation
          à tout moment. Toute modification de celles-ci devra être acceptée par
          l’Utilisateur afin de lui permettre de continuer à accéder à CAnnect.
        </p>
        <p>
          Les Conditions Générales d’Utilisation sont accessibles et imprimables �
          tout moment par un lien direct en bas de page de CAnnect.
        </p>
        <p>
          L’Utilisateur demeure seul responsable sans aucune réserve de toutes les
          actions qu’il effectue sur CAnnect.
        </p>
        <p>
          CAnnect est accessible sur le réseau informatique interne uniquement et
          s’appuie sur une solution développée et exploitée par CACIB pour laquelle
          une licence d’utilisation a été accordée à CAI. La solution est hébergée
          par Microsoft Azure dans un datacenter localisé en France. Une équipe au
          sein du département des Ressources Humaines de CAI en assure l’animation et
          l’administration (ci-après les « <strong>Administrateurs</strong> »).
        </p>
      </div>
      <div class="section">
        <h3>Article 1 : Accès à CAnnect</h3>
        <div class="subsection">
          <h4>1.1 Utilisateurs autorisés</h4>
          <p>
            CAnnect est accessible uniquement aux personnes physiques suivantes
            (ci-après « <strong>les Utilisateurs</strong> ») :
          </p>
          <table>
            <tbody>
              <tr>
                <td>
                  (i)
                </td>
                <td>
                  Les collaborateurs de CAI
                </td>
              </tr>
              <tr>
                <td>
                  (ii)
                </td>
                <td>
                  Les collaborateurs<sup>1</sup> des Entités Indosuez
                </td>
              </tr>
              <tr>
                <td>
                  (iii)
                </td>
                <td>
                  Les collaborateurs<sup>1</sup> de tout prestataire externe
                  intervenant au sein de CAI, dans le cadre d’un contrat de
                  prestation conclu avec CAI et disposant d’un accès au
                  réseau informatique de CAI.
                </td>
              </tr>
              <tr>
                <td>
                  (iv)
                </td>
                <td>
                  Les collaborateurs<sup>1</sup> de tout prestataire externe
                  intervenant au sein d’une Entité Indosuez, dans le cadre
                  d’un contrat de prestation conclu avec cette dernière et
                  disposant d’un accès au réseau informatique de l’Entité
                  Indosuez.
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            <small><sup>1</sup> Le terme "collaborateur" désigne toute personne titulaire d’un contrat
              de travail ou de tout autre type de contrat assimilé, en ce compris les personnes détachées
              ou mises à disposition, les personnes titulaires d’un contrat d’apprentissage et d’un contrat
              de professionnalisation. Sont également inclus dans cette définition les stagiaires
              et les intérimaires.</small>
          </p>
        </div>
        <div class="subsection">
          <h4>1.2 Accessibilité</h4>
          <p>
            L’Utilisateur peut accéder à CAnnect, au titre de son activité
            professionnelle, uniquement aux jours et horaires normaux de travail prévus
            par les lois, règlements et conventions qui lui sont applicables.
          </p>
          <p>
            L’Utilisateur s’engage à utiliser CAnnect pendant une durée raisonnable de
            telle sorte que sa durée quotidienne d’utilisation de CAnnect ne soit pas
            supérieure à celle accordée à son activité professionnelle habituelle
            principale.
          </p>
          <p>
            L’Utilisateur est également informé que CAnnect peut faire l’objet de
            modifications ou cesser d’être mis à disposition, à tout moment, sans
            préavis. Par ailleurs, CAnnect pourra faire l’objet d’évolution via
            l’intégration de nouvelles fonctionnalités ou la suppression de certaines
            d’entre elles.
          </p>
        </div>
        <div class="subsection">
          <h4>1.3 Mot de passe</h4>
          <p>
            Le système CAnnect ne demande pas à l’Utilisateur de s’authentifier, mais
            utilise un mécanisme de Single Sign On (SSO) pour authentifier
            l’Utilisateur déjà connecté au système d’information de CAI ou de l’Entité
            Indosuez à laquelle il est rattaché.
          </p>
          <p>
            Si l’Utilisateur a connaissance d’une usurpation de ses moyens
            d’identification il doit les modifier et en informer immédiatement CAI ou
            l’Entité Indosuez à laquelle il est rattaché.
          </p>
        </div>
      </div>
      <div class="section">
        <h3>Article 2 : Connexion de l’Utilisateur sur CAnnect</h3>
        <p>
          Lors de sa première connexion l’Utilisateur a la possibilité de compléter
          son profil personnel (ci-après le « <strong>Profil</strong> »). Le Profil
          est automatiquement complété avec les informations professionnelles
          suivantes : le nom, le prénom, la localisation professionnelle, le métier
          d’appartenance, l’adresse email. L’Utilisateur n’a pas la possibilité de
          modifier ces informations.
        </p>
        <p>
          L’Utilisateur peut également compléter son Profil avec des informations
          personnelles telles que ses centres intérêts et les langues qu’il maîtrise.
        </p>
        <p>
          L’Utilisateur garantit que toutes les informations qu’il complète dans le
          Profil sont à jour et sincères et ne sont entachées d’aucun caractère
          trompeur. Il s’engage à mettre à jour ces informations en cas de
          modifications. L’Utilisateur peut également y renseigner ses souhaits
          concernant la gestion de ses notifications dans CAnnect.
        </p>
        <p>
          Les données publiées par les Utilisateurs sur leurs Profils seront visibles
          par l’ensemble des autres Utilisateurs pour permettre la constitution des
          communautés, le partage et les échanges de connaissances sur CAnnect. Les
          Utilisateurs peuvent mettre à jour les informations de leurs Profils à tout
          moment en corrigeant ces informations sur leurs Profils.
        </p>
      </div>
      <div class="section">
        <h3>Article 3 : Description des fonctionnalités proposées de CAnnect</h3>
        <p>
          Les fonctionnalités suivantes sont proposées sur CAnnect aux Utilisateurs :
        </p>
        <div class="subsection">
          <h4>3.1 Publication de Contenus par les Utilisateurs</h4>
          <p>
            CAnnect est un réseau social d’entreprise permettant à ses collaborateurs
            de publier et consulter des contenus écrits, des images et des commentaires
            sur les publications des autres Utilisateurs (ci-après « <strong>le/les Contenu(s)</strong> ») afin de
            faciliter les échanges, la
            mise en relation, l’entraide et le développement des réseaux professionnels
            entre eux.
          </p>
          <p>
            CAnnect ne se substitue pas aux outils informatiques sécurisés mis à la
            disposition des Utilisateurs, notamment les plateformes d’échanges
            sécurisées ou les outils de gestion de projets informatiques qu’il convient
            d’utiliser conformément aux procédures internes en vigueur au sein de CAI
            ou de l’Entité Indosuez à laquelle l’Utilisateur est rattaché.
          </p>
          <p>
            Les groupes de discussions personnelles y sont permis dans le respect des
            présentes Conditions Générales d’Utilisation.
          </p>
          <p>
            L’Utilisateur est informé que l’ensemble du Contenu qu’il publie est
            archivé en temps réel pour répondre à des obligations règlementaires
            notamment dans le cadre de la prévention de la fraude, de la lutte contre
            les abus de marché et de la prévention des conflits d’intérêts.
          </p>
        </div>
        <div class="subsection">
          <h4>3.2 Communautés thématiques</h4>
          <p>
            Chaque Utilisateur peut créer à son initiative des communautés thématiques
            (ci-après la/les « <strong>Communautés</strong> »), publiques ou privées,
            afin d’échanger uniquement avec un groupe d’Utilisateurs déterminés qui
            peuvent partager des centres d’intérêts commun ou être dans la même équipe.
          </p>
          <p>
            Lorsque l’Utilisateur rejoint une Communauté il peut y participer et
            accéder au fil d’actualité de celle-ci. La liste de l’ensemble des
            Communautés dont l’Utilisateur est membre sera visible depuis son Profil.
          </p>
        </div>
        <div class="subsection">
          <h4>3.2.1 Création d’une Communauté</h4>
          <p>
            Chaque Utilisateur peut créer une Communauté et sera alors identifié comme
            leader de la Communauté (ci-après le « <strong>Leader</strong> »). Le
            Leader doit donner un nom, un visuel et une description à la Communauté
            ainsi créée.
          </p>
          <p>
            Il appartient au Leader de déterminer si la visibilité de la Communauté
            est publique, tous les Utilisateurs de CAnnect pourront alors y accéder, ou
            privée, seuls les Utilisateurs membres de cette Communauté pourront y
            accéder.
          </p>
          <p>
            Les Communautés inactives depuis plus de 6 mois pourront être supprimées
            par les Administrateurs après en avoir préalablement informé le Leader.
          </p>
        </div>
        <div class="subsection">
          <h4>3.2.2 Rôle du Leader d’une Communauté</h4>
          <p>
            Le Leader d’une Communauté peut notamment :
          </p>
          <table>
            <tbody>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Inviter d’autres Utilisateurs à rejoindre sa Communauté ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Accepter ou refuser les demandes d’Utilisateur pour
                  rejoindre une Communauté privée ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Identifier les Utilisateurs autorisés à publier du Contenu
                  sur la Communauté privée (ci-après les « <strong>Utilisateurs Broadcaster</strong> »). Par défaut
                  tous les Utilisateurs membre d’une Communauté privée sont
                  autorisés à publier du Contenu ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Nommer un nouveau Leader de la communauté. Cette action
                  entrainera la perte de ses droits de Leader et de membre de
                  la communauté. Il aura la possibilité de refaire une
                  demande pour être uniquement membre de la Communauté ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Modifier le nom, la description et le visuel de la
                  Communauté ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Signaler à l’Administrateur un Contenu qui ne respecterait
                  pas les présentes Conditions Générales d’Utilisation
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="subsection">
          <h4>3.2.3 Rôle des Utilisateurs d’une Communauté</h4>
          <p>
            Les Utilisateurs membres d’une Communauté peuvent notamment :
          </p>
          <table>
            <tbody>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Poster des Contenus dans la Communauté et commenter celles
                  des autres membres, sauf dans les Communautés privées pour
                  lesquelles le Leader ne l’aurait pas identifié comme
                  Utilisateur Broadcaster ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Éditer et supprimer ses Contenus ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Quitter une Communauté à tout moment. Cette action
                  n’entraîne pas la suppression automatique du Contenu publié
                  par l’Utilisateur ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  Signaler à l’Administrateur un Contenu qui ne respecterait
                  pas les présentes Conditions Générales d’Utilisation ;
                </td>
              </tr>
              <tr>
                <td>
                  -
                </td>
                <td>
                  « Aimer » et « Suivre » des Contenus selon ses préférences.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="section">
        <h3>Article 4 : Obligations des Utilisateurs</h3>
        <p>
          L’Utilisateur s’engage, dans son usage de CAnnect, à respecter les lois et
          règlements en vigueur et à ne pas porter atteinte aux droits de tiers ou �
          l’ordre public. L’Utilisateur s’engage notamment à détenir toutes les
          licences ou autorisations nécessaires sur les Contenus qu’il publie et
          diffuse sur CAnnect.
        </p>
        <p>
          L’Utilisateur demeure seul responsable de toutes les conséquences de son
          utilisation de CAnnect y compris concernant les Contenus qui seraient
          publiés par un tiers à l’aide de ses identifiants, qu’il s’agisse de tiers
          autorisés ou non. L’Utilisateur reconnaît ainsi qu’il est seul responsable
          du Contenu posté sur CAnnect via son Profil ainsi que des conséquences
          liées à la mise en ligne, la transmission, la publication ou tout autre
          divulgation de Contenu.
        </p>
        <p>
          Les Utilisateurs s’engagent à signaler aux Administrateurs tout Contenu qui
          ne respecterait pas les présentes Conditions Générales d’Utilisation.
        </p>
        <p>
          Il dispose à ce titre dans CAnnect des fonctionnalités suivantes :
        </p>
        <table>
          <tbody>
            <tr>
              <td>
                -
              </td>
              <td>
                « <strong>Signaler un post</strong> » : accessible pour
                chacun des Contenus publiés par un Utilisateur ;
              </td>
            </tr>
            <tr>
              <td>
                -
              </td>
              <td>
                « <strong>Signaler un commentaire</strong> », accessible
                pour chacun des commentaires publiés par un utilisateur ;
              </td>
            </tr>
            <tr>
              <td>
                -
              </td>
              <td>
                « <strong>Signaler une communauté</strong> », accessible
                dans la page descriptive de la Communauté.
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          Il peut également contacter directement l’équipe d’Administrateurs �
          l’adresse email <a class="link" href="mailto:cannectadmin@ca.indosuez.lu">cannectadmin@ca.indosuez.lu</a>
          en indiquant le Contenu concerné et le motif du signalement.
        </p>
        <p>
          Tout signalement pourra faire l’objet, après appréciation des
          Administrateurs, d’une suspension ou d’une suppression du compte de
          l’Utilisateur.
        </p>
      </div>
      <div class="section">
        <h3>Article 5 : Comportements prohibés</h3>
        <p>
          Il est strictement interdit aux Utilisateurs d’utiliser CAnnect, notamment
          dans ses Contenus et commentaires aux fins suivantes :
        </p>
        <table>
          <tbody>
            <tr>
              <td>
                a)
              </td>
              <td>
                l’exercice d’activités illégales, frauduleuses ou portant
                atteinte aux droits ou à la sécurité des tiers ;
              </td>
            </tr>
            <tr>
              <td>
                b)
              </td>
              <td>
                l’atteinte à l’ordre public ou la violation des lois et
                règlements en vigueur ;
              </td>
            </tr>
            <tr>
              <td>
                c)
              </td>
              <td>
                l’intrusion dans le système informatique d’un tiers ou
                toute activité de nature à nuire, contrôler, interférer, ou
                intercepter tout ou partie du système informatique d’un
                tiers, en violer l’intégrité ou la sécurité ;
              </td>
            </tr>
            <tr>
              <td>
                d)
              </td>
              <td>
                communiquer des informations privilégiées ;
              </td>
            </tr>
            <tr>
              <td>
                e)
              </td>
              <td>
                communiquer des informations soumises au secret
                professionnel ;
              </td>
            </tr>
            <tr>
              <td>
                f)
              </td>
              <td>
                télécharger ou transmettre par l’intermédiaire de la
                CAnnect tout contenu diffamatoire, injure, atteinte �
                l’honneur, incitation à la haine raciale et la
                discrimination ou faisant l’apologie des crimes de guerre
                ou crimes contre l’humanité, religieux, à caractère
                prosélytique ;
              </td>
            </tr>
            <tr>
              <td>
                g)
              </td>
              <td>
                l’envoi d’emails non sollicités et/ou de prospection ou
                sollicitation commerciale ;
              </td>
            </tr>
            <tr>
              <td>
                h)
              </td>
              <td>
                les manipulations destinées à améliorer le référencement
                d’un site tiers ;
              </td>
            </tr>
            <tr>
              <td>
                i)
              </td>
              <td>
                l’aide ou l’incitation, sous quelque forme et de quelque
                manière que ce soit, à un ou plusieurs des actes et
                activités décrits ci-dessus ;
              </td>
            </tr>
            <tr>
              <td>
                j)
              </td>
              <td>
                aider un tiers non autorisé à accéder à CAnnect ;
              </td>
            </tr>
            <tr>
              <td>
                k)
              </td>
              <td>
                et plus généralement toute pratique détournant CAnnect �
                des fins autres que celles pour lesquelles il a été conçu ;
              </td>
            </tr>
            <tr>
              <td>
                l)
              </td>
              <td>
                copier et/ou détourner à leurs fins ou à celles de tiers le
                concept, les technologies ou tout autre élément de CAnnect
                ;
              </td>
            </tr>
            <tr>
              <td>
                m)
              </td>
              <td>
                tout comportement de nature à interrompre, suspendre,
                ralentir ou empêcher la continuité des Services ;
              </td>
            </tr>
            <tr>
              <td>
                n)
              </td>
              <td>
                toute intrusion ou tentative d’intrusion dans les systèmes
                de CAI ou de toute Entité Indosuez ;
              </td>
            </tr>
            <tr>
              <td>
                o)
              </td>
              <td>
                tout détournement des ressources système de CAnnect ;
              </td>
            </tr>
            <tr>
              <td>
                p)
              </td>
              <td>
                toute action de nature à imposer une charge
                disproportionnée sur les infrastructures de cette dernière
                ;
              </td>
            </tr>
            <tr>
              <td>
                q)
              </td>
              <td>
                toute atteinte aux mesures de sécurité et
                d’authentification ;
              </td>
            </tr>
            <tr>
              <td>
                r)
              </td>
              <td>
                tout acte de nature à porter atteinte aux droits et
                intérêts financiers, commerciaux ou moraux de CAI ou de
                toute Entité Indosuez ;
              </td>
            </tr>
            <tr>
              <td>
                s)
              </td>
              <td>
                monnayer, vendre ou concéder tout ou partie de l’accès aux
                Services ou à CAnnect, ainsi qu’aux informations qui y sont
                hébergées et/ou partagées ;
              </td>
            </tr>
            <tr>
              <td>
                t)
              </td>
              <td>
                et enfin plus généralement tout manquement aux présentes
                Conditions Générales d’Utilisation.
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          Les Contenus publiés par l’Utilisateur doivent respecter les règles
          internes, en vigueur au sein de CAI ou de l’Entité Indosuez à laquelle il
          est rattaché, auxquelles il est soumis, notamment au regard de la
          protection des données à caractère personnel, du secret bancaire et de la
          sécurité des systèmes d’information.
        </p>
        <p>
          L’Utilisateur s’engage également à respecter les règles applicables au sein
          de CAI ou de l’Entité Indosuez à laquelle il est rattachée, découlant
          notamment de tout texte de nature interne tel que code de conduite
          règlement intérieur ou document équivalent.
        </p>
        <p>
          De même, il s’engage à ne pas publier sur CAnnect des liens hypertextes
          vers des sites extérieurs à CAI ou à l’Entité Indosuez à laquelle il est
          rattaché dont le contenu serait contraire à la législation et à la
          réglementation en vigueur, ainsi qu’aux présentes Conditions Générales
          d’Utilisation.
        </p>
        <p>
          Les Administrateurs se réservent le droit de supprimer partiellement ou
          dans sa totalité tout Contenu qui ne respecterait pas les présentes
          Conditions Générales d’Utilisation, conformément à l’article 9 des
          présentes, et notamment les contenus agressifs, grossiers, hors sujets,
          sexistes, homophobes, racistes ou à caractère mercantile.
        </p>
      </div>
      <div class="section">
        <h3>Article 6 : Propriété intellectuelle</h3>
        <div class="subsection">
          <h4>6.1 Propriété Intellectuelle de CACIB</h4>
          <p>
            CACIB détient tous les droits de propriété intellectuelle sur tous les
            systèmes, logiciels, structures, infrastructures, bases de données et
            contenus de toute nature (textes, images, visuels, musiques, logos,
            marques, base de données, noms de domaine etc.) utilisés sur CAnnect qui
            sont protégés par tout droit de propriété intellectuelle ou droit des
            producteurs de bases de données en vigueur.
          </p>
          <p>
            CAnnect et chacun des éléments qui la compose sont la propriété exclusive
            de CACIB.
          </p>
          <p>
            Tout désassemblage, décompilation, décryptage, extraction, réutilisation,
            copie et plus généralement, tout acte de reproduction, représentation,
            diffusion et utilisation de l’un de ces éléments quel qu’il soit, en tout
            ou partie, sans l’autorisation de CACIB, est strictement interdit et pourra
            faire l’objet de poursuites judiciaires.
          </p>
        </div>
        <div class="subsection">
          <h4>6.2 Contenus sous la responsabilité des Utilisateurs</h4>
          <p>
            L’Utilisateur reconnait qu’il est seul responsable de ses Contenus sur
            CAnnect et notamment quant à leur exactitude, leur qualité et leur licéité.
            L’Utilisateur est seul responsable des conséquences liées à la mise en
            ligne, transmission, publication des Contenus.
          </p>
          <p>
            L’Utilisateur reste propriétaire des éventuels droit de propriété
            intellectuelle sur ses Contenus non professionnels mis en ligne sur
            CAnnect.
          </p>
          <p>
            Par conséquent, quand il crée sur CAnnect un Contenu sur lequel il dispose
            de tels droits, l’Utilisateur accepte expressément d’accorder à CAI un
            droit d’utilisation de ce contenu.
          </p>
          <p>
            Ce droit est conféré par l’Utilisateur à titre gratuit. Il est non-exclusif
            et non-cessible, limité au support CAnnect pour le monde entier et pendant
            toute la durée de ses droits.
          </p>
        </div>
        <div class="subsection">
          <h4>6.3 Droits des tiers</h4>
          <p>
            L’Utilisateur ne doit pas poster, envoyer, stocker de Contenus portant
            atteinte aux droits de propriété intellectuelle (droit d’auteur, droits
            voisins, droit sui generis du producteur de base de données, droit des
            marques, noms de domaine…) ou droit à la vie privée de tout tiers.
          </p>
          <p>
            Les citations de textes de tiers doivent se limiter à de courts extraits,
            non modifiés, être mis entre guillemets, avec la mention obligatoire de la
            source. Les images et photos mises en ligne doivent être libres de droit.
            Dans le cas contraire l’Utilisateur doit s’assurer de l’accord préalable de
            leur propriétaire avant toute publication. De même, avant de mettre en
            ligne toute photo représentant des personnes identifiables autres que
            l’Utilisateur, ce dernier doit avoir recueilli leur consentement à la
            publication sur CAnnect.
          </p>
          <p>
            L’Utilisateur demeure seul responsable de tous les Contenus qu’il poste sur
            CAnnect depuis son compte. La responsabilité de CAI ou d’une Entité
            Indosuez ne peut pas être engagée pour tout dommage, réclamation relative �
            une utilisation non conforme de CAnnect par l’Utilisateur.
          </p>
        </div>
      </div>
      <div class="section">
        <h3>Article 7 : Données personnelles</h3>
        <p>
          CAI met en place un réseau social d’entreprise afin de permettre aux
          Utilisateurs de partager de l’information et de développer leur réseau
          professionnel selon leurs centres d’intérêts professionnel et personnel au
          travers de communautés thématiques.
        </p>
        <p>
          Dans ce cadre CAI met en œuvre le traitement de données à caractère
          personnel suivant :
        </p>
        <p>
          Administration, gestion et animation des communautés privées ou publiques
        </p>
        <table>
          <tbody>
            <tr>
              <td>
                Base légale permettant le traitement
              </td>
              <td>
                L’intérêt légitime (qui consiste à offrir des canaux de
                communication aux Utilisateurs)
              </td>
            </tr>
            <tr>
              <td>
                Durée de conservation des données
              </td>
              <td>
                Compte tenu des obligations règlementaires de CAI en
                matière de surveillance des abus de marché, et de son
                intérêt légitime à lutter contre la corruption et de
                fraude, l’ensemble des Contenus publié par un Utilisateur
                du réseau social d’entreprise, visibles sur CAnnect par les
                autres Utilisateurs, sera anonymisé 6 mois après le départ
                dudit collaborateur. Toutefois, l’intégralité des contenus
                publiés par un Utilisateur demeurent conservée dans la base
                de données, <strong>de manière non anonymisée</strong>,
                pendant 5 ans.
              </td>
            </tr>
            <tr>
              <td>
                Destinataires des données
              </td>
              <td>
                Entités de CA Indosuez Group
              </td>
            </tr>
            <tr>
              <td>
                Transfert des données vers un pays non membre de l’UE
              </td>
              <td>
                Pas de transfert en dehors de l’UE
              </td>
            </tr>
            <tr>
              <td>
                Données obtenues auprès de tiers
              </td>
              <td>
                Non
              </td>
            </tr>
            <tr>
              <td>
                Responsable de traitement
              </td>
              <td>
                HRE
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          Pour pouvoir proposer ces services CAI est amené à collecter des données
          d’identification et des données de vie professionnelle.
        </p>
        <p>
          L’Utilisateur dispose des droits suivants sur les données personnelles le
          concernant que CAI collecte et traite en qualité de responsable de
          traitement :
        </p>
        <table>
          <tbody>
            <tr>
              <td>
                -
              </td>
              <td>
                droit d'accès, de rectification et d’effacement des données
                (inexactes, incomplètes, équivoques, ou périmées) ;
              </td>
            </tr>
            <tr>
              <td>
                -
              </td>
              <td>
                droit d’opposition au traitement de vos données ;
              </td>
            </tr>
            <tr>
              <td>
                -
              </td>
              <td>
                droit à la limitation du traitement de vos données dans les
                conditions prévues par la règlementation ;
              </td>
            </tr>
            <tr>
              <td>
                -
              </td>
              <td>
                droit à la portabilité des données ;
              </td>
            </tr>
            <tr>
              <td>
                -
              </td>
              <td>
                droit de retirer son consentement à tout moment, sans
                porter atteinte à la licéité du traitement fondé sur le
                consentement effectué avant le retrait de celui-ci ;
              </td>
            </tr>
            <tr>
              <td>
                -
              </td>
              <td>
                droit d'introduire une réclamation.
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          L’Utilisateur peut exercer ces droits en adressant une demande écrite au
          Délégué à la Protection des Données de CAI ou de l’Entité Indosuez �
          laquelle il est rattaché (coordonnées en annexe). Dans l’hypothèse où
          l’Utilisateur ne serait pas satisfait de la réponse apportée, il peut
          s’adresser à l’autorité compétente en matière de protection des données
          dont dépend CAI ou l’Entité Indosuez à laquelle il est rattaché.
        </p>
      </div>
      <div class="section">
        <h3>
          Article 8 : Obligations et responsabilités de CAI et des Entités
          Indosuez
        </h3>
        <p>
          L’intervention de CAI et des Entités Indosuez se limite à mettre �
          disposition des Utilisateurs une plateforme en ligne leur permettant
          d’échanger. Elle ne saurait en aucun cas être responsable des relations
          entre les Utilisateurs dans le cadre de leur utilisation de CAnnect.
        </p>
        <p>
          CAI et les Entités Indosuez ne sauraient être tenus responsables des
          Contenus publiés par les Utilisateurs et notamment des Contenus qu’ils
          publieraient sans être titulaires des droits de propriété intellectuelle ou
          sans le consentement de l’auteur.
        </p>
        <p>
          CAI et les Entités Indosuez ne garantissent pas que CAnnect, soumise à une
          recherche constante pour en améliorer notamment la performance et le
          progrès, sera totalement exempte d’erreurs, de vices ou défauts.
        </p>
        <p>
          CAI et les Entités Indosuez peuvent procéder à des contrôles afin de
          vérifier le fonctionnement et l’accessibilité de CAnnect et en modifier les
          fonctionnalités. A ce titre, CAI et les Entités Indosuez se réservent la
          faculté d’interrompre momentanément l’accès à CAnnect pour des raisons de
          maintenance. De la même façon, CAI et les Entités Indosuez ne sauraient
          être tenus responsables des difficultés ou impossibilités momentanées
          d’accès à CAnnect qui auraient pour origine des circonstances qui lui sont
          extérieures, la force majeure, ou encore qui seraient dues à des
          perturbations des réseaux de télécommunication.
        </p>
      </div>
      <div class="section">
        <h3>Article 9 : Modération des Contenus par CAI</h3>
        <p>
          CAI n’a pas d’obligation générale de vérification a priori des Contenus
          publiés par les Utilisateurs et les Administrateurs de CAnnect n’effectuent
          aucune modération a priori (humaine ou automatique) sur les Contenus mis en
          ligne par les Utilisateurs. CAI procède uniquement à un contrôle a
          posteriori des Contenus.
        </p>
        <p>
          Les Administrateurs de CAnnect se réservent le droit à tout moment de
          supprimer dans les meilleurs délais tout Contenu qui leur serait signalé ou
          dont ils prendraient connaissance et qui serait manifestement illicite ou
          contraire aux présentes Conditions Générales d’Utilisation.
        </p>
        <p>
          En présence de Contenus ou d’actions contraires aux Présentes Conditions
          Générales d’Utilisation les Administrateurs pourront suspendre
          temporairement l’accès de l’Utilisateur à CAnnect ou supprimer
          définitivement le compte de l’Utilisateur.
        </p>
        <p>
          Ces mesures ne sont pas exclusives des sanctions qui pourraient être prises
          en cas de constatation d’un manquement aux règles de disciplines.
        </p>
      </div>
      <div class="section">
        <h3>Article 10 : Désinscription - Suppression du compte d’un Utilisateur</h3>
        <p>
          L’accès de l’Utilisateur à CAnnect peut être supprimé ou restreint dans les
          circonstances suivantes :
        </p>
        <table>
          <tbody>
            <tr>
              <td>
                (i)
              </td>
              <td>
                à la demande expresse de l’Utilisateur ;
              </td>
            </tr>
            <tr>
              <td>
                (ii)
              </td>
              <td>
                automatiquement après le départ de l’Utilisateur de CAI ou
                de l’Entité Indosuez à laquelle il est rattaché;
              </td>
            </tr>
            <tr>
              <td>
                (iii)
              </td>
              <td>
                En cas de manquement à une quelconque des dispositions des
                présentes Conditions Générales d’Utilisation ou plus
                généralement, d’infraction aux lois et règlements en
                vigueur par un Utilisateur. Dans ces circonstances, CAI et
                l’Entité Indosuez à laquelle l’Utilisateur est rattaché se
                réserve le droit de prendre toute mesure appropriée et
                notamment d’avertir toute autorité judiciaire concernée et
                engager toute action judiciaire.
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          La suppression des accès entraîne l’anonymisation des Contenus de
          l’Utilisateur 6 mois après son départ de CAI ou de l’Entité Indosuez �
          laquelle il est rattaché conformément à l’article 7 des présentes
          Conditions Générales d’Utilisation.
        </p>
      </div>
      <div class="section">
        <h3>Article 11 : Utilisation de cookies</h3>
        <p>
          L’application CAnnect utilise des témoins de connexion ou « cookies »
          visant exclusivement à assurer une connexion automatique à l’application
          via la session Windows de l’Utilisateur et simplifier sa navigation. Ces
          traceurs sont chiffrés et lisibles uniquement par l’application.
        </p>
        <p>
          Des mesures d’audience sont réalisées sur le site à l’aide d’outils internes ou de prestataires tiers,
          dans le but d’analyser la fréquentation, les parcours de navigation et l’interaction avec les contenus.
          Ces traitements sont effectués sur la base de l’intérêt légitime de l’entreprise à améliorer la qualité du service,
          à en assurer le bon fonctionnement et à adapter les contenus aux besoins des utilisateurs.
          Les données collectées sont traitées conformément à la réglementation applicable en matière de protection des données personnelles,
          notamment le Règlement Général sur la Protection des Données (RGPD).
        </p>
        <p>
          Pour plus d’informations, les utilisateurs sont invités à consulter l’article 7 des présentes CGU."
        </p>
      </div>
      <div class="section">
        <h3>Article 12 : Modification des présentes Conditions Générales d’Utilisation</h3>
        <p>
          CAI se réserve le droit de modifier à tout moment et sans préavis, les
          présentes Conditions Générales d’Utilisation et l’étendue des
          fonctionnalités proposées sur CAnnect.
        </p>
        <p>
          Les Utilisateurs seront informés de toute modification des Conditions
          Générales d’Utilisation. L’Utilisateur devra alors accepter les nouvelles
          Conditions Générales d’Utilisation sans quoi il ne pourra plus continuer �
          utiliser CAnnect.
        </p>
      </div>
      <div class="section">
        <h3>Article 13 : Droit applicable et juridiction</h3>
        <p>
          Les Conditions Générales d’Utilisation sont régies par le droit français.
        </p>
        <p>
          L’Utilisateur et CAI ou l’Entité Indosuez à laquelle il est rattaché
          conviennent de rechercher une solution amiable à tout différend qui les
          oppose. A défaut de solution amiable, les tribunaux de Paris seront seuls
          compétents.
        </p>
        <p>
          Les Conditions Générales d’Utilisation entrent en vigueur à compter du
          01/01/2022.
        </p>
      </div>
    </div>
    <div class="bloc annexe">
      <h3>ANNEXE Coordonnées DPO</h3>
      <table>
        <thead>
          <tr>
            <th>
              <strong>ENTITE</strong>
            </th>
            <th>
              Adresse Postale DPO
            </th>
            <th>
              Adresse mail DPO
            </th>
            <th>
              Contact régulateur local
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>CA INDOSUEZ</strong>
            </td>
            <td>
              CA INDOSUEZ
              Data Protection Officer
              17 rue du Docteur Lancereaux
              75382 Paris cedex 08 France
            </td>
            <td>
              <a class="link" href="mailto:dpo@ca-indosuez.com">dpo@ca-indosuez.com</a>
            </td>
            <td rowspan="3">
              <strong>
                Commission nationale de l’informatique et des libertés
                (CNIL)
              </strong>
              3 place de Fontenoy
              TSA 80715
              75334 PARIS CEDEX 07
            </td>
          </tr>
          <tr>
            <td>
              <strong>VALBAUME IMMOBILIER</strong>
            </td>
            <td>
              Valbaume Immobilier
              Data Protection Officer
              17 rue du Docteur Lancereaux
              75382 Paris cedex 08 France
            </td>
            <td>
              <a class="link" href="mailto:dpo@ca-indosuez.com">dpo@ca-indosuez.com</a>
            </td>
          </tr>
          <tr>
            <td>
              <strong>CA INDOSUEZ GESTION</strong>
            </td>
            <td>
              CA INDOSUEZ GESTION
              Data Protection Officer
              17 rue du Docteur Lancereaux
              75382 Paris cedex 08 France
            </td>
            <td>
              <a class="link" href="mailto:dpo@ca-indosuez.com">dpo@ca-indosuez.com</a>
            </td>
          </tr>
          <tr>
            <td>
              <strong>CA INDOSUEZ WEALTH (EUROPE)</strong>
            </td>
            <td>
              CA Indosuez Wealth (Europe)
              Dat aProtection Officer
              39 Allée Scheffer
              2520 Luxembourg
            </td>
            <td>
              <a class="link" href="mailto:dpo@ca-indosuez.lu">dpo@ca-indosuez.lu</a>
            </td>
            <td>
              <strong>
                Commission Nationale pour la Protection des Données
              </strong>
              15, boulevard du Jazz
              L-4370 Belvaux
            </td>
          </tr>
          <tr>
            <td>
              <strong>
                CA INDOSUEZ WEALTH (EUROPE), SUCURSAL EN ESPAÑA
              </strong>
            </td>
            <td>
              CA Indosuez Wealth (Europe), Sucursal en España
              Data Protection Officer
              Paseo de la Castellana, 1
              28046 Madrid, Espagne
            </td>
            <td>
              <a class="link" href="mailto:dpo@ca-indosuez.es">dpo@ca-indosuez.es</a>
            </td>
            <td>
              <strong>Agencia de Protección de Datos </strong>
              C/Jorge Juan, 6
              28001 Madrid
            </td>
          </tr>
          <tr>
            <td>
              <strong>CA INDOSUEZ WEALTH (EUROPE) BELGIUM BRANCH</strong>
            </td>
            <td>
              CA Indosuez Wealth (Europe) Belgium Branch
              Data Protection Officer
              Chaussée de la Hulpe 120
              1000 Bruxelles, Belgique
            </td>
            <td>
              <a class="link" href="mailto:dpo@ca-indosuez.be">dpo@ca-indosuez.be</a>
            </td>
            <td>
              <strong>Autorité de la protection des données</strong>
              Rue de la Presse 35
              1000 Brussel
            </td>
          </tr>
          <tr>
            <td>
              <strong>CA INDOSUEZ WEALTH (ITALIE) S.P.A.</strong>
            </td>
            <td>
              CA Indosuez Wealth (Italy) S.p.a.
              Data Protection Officer
              Piazza Cavour, 2
              20121 Milano MI, Italie
            </td>
            <td>
              <a class="link" href="mailto:dpo@ca-indosuez.it">dpo@ca-indosuez.it</a>
            </td>
            <td>
              <strong>
                Garante per la protezione dei dati personali
              </strong>
              Piazza Venezia, 11
              00187 Roma
            </td>
          </tr>
          <tr>
            <td>
              <strong>CA INDOSUEZ WEALTH (ASSET MANAGEMENT)</strong>
            </td>
            <td>
              CA Indosuez Wealth (Asset Management),
              31-33 avenue Pasteur, L-2311 Luxembourg
            </td>
            <td>
              <a class="link" href="mailto:dataprotectionofficer@ca-indosuez-am.com">dataprotectionofficer@ca-indosuez-am.com</a>
            </td>
            <td rowspan="2">
              <strong>
                Commission Nationale pour la Protection des Données
              </strong>
              15, boulevard du Jazz
              L-4370 Belvaux
            </td>
          </tr>
          <tr>
            <td>
              <strong>CA INDOSUEZ PRIVATE EQUITY</strong>
            </td>
            <td>
              CA Indosuez Wealth (Asset Management),
              31-33 avenue Pasteur, L-2311 Luxembourg
            </td>
            <td>
              <a class="link" href="mailto:dataprotectionofficer@ca-indosuez-am.com">dataprotectionofficer@ca-indosuez-am.com</a>
            </td>
          </tr>
          <tr>
            <td>
              <strong>CFM INDOSUEZ (MONACO)</strong>
            </td>
            <td>
              CFM Indosuez (Monaco)
              Data Protection Officer
              11 Boulevard Albert 1er
              98000 Monaco
            </td>
            <td>
              <a class="link" href="mailto:data-protection-officer@cfm-indosuez.mc">data-protection-officer@cfm-indosuez.mc</a>
            </td>
            <td rowspan="2">
              <strong>
                Commission de Contrôle des Informations Nominatives
              </strong>
              12 Avenue de Fontvieille
              98000 Monaco
            </td>
          </tr>
          <tr>
            <td>
              <strong>CFM INDOSUEZ GESTION</strong>
            </td>
            <td>
              CFM Indosuez Gestion
              Data Protection Officer
              11 Boulevard Albert 1er
              98000 Monaco
            </td>
            <td>
              <a class="link" href="mailto:data-protection-officer@cfm-indosuez.mc">data-protection-officer@cfm-indosuez.mc</a>
            </td>
          </tr>
          <tr>
            <td>
              <strong>CFM Indosuez Conseil en Investissement</strong>
            </td>
            <td>
              CFM Indosuez Conseil en Investissement
              Data Protection Officer, 1 Place de la Liberté – Bâtiment C
              La Lombarde, 06320 Cap d’Ail
            </td>
            <td>
              <a class="link" href="mailto:data-protection-officer@ci-cfm-indosuez.com">data-protection-officer@ci-cfm-indosuez.com</a>
            </td>
            <td>
              <strong>
                Commission nationale de l’informatique et des libertés
                (CNIL)
              </strong>
              3 place de Fontenoy
              TSA 80715
              75334 PARIS CEDEX 07
            </td>
          </tr>
          <tr>
            <td>
              <strong>CA INDOSUEZ (SWITZERLAND) SA</strong>
            </td>
            <td rowspan="3">
              CA Indosuez (Switzerland) SA
              Data Protection Officer
              Quai Général-Guisan 4
              Case Postale 5260
              1211 Genève 11
            </td>
            <td rowspan="3">
              <a class="link" href="mailto:dpo@ca-indosuez.ch">dpo@ca-indosuez.ch</a>
            </td>
            <td rowspan="4">
              <strong>
                Préposé fédéral à la protection des données et à la
                transparence
              </strong>
              Feldeggweg 1
              3003 Berne
              Suisse
            </td>
          </tr>
          <tr>
            <td>
              <strong>
                CA INDOSUEZ (SWITZERLAND) SA SINGAPORE BRANCH
              </strong>
            </td>
          </tr>
          <tr>
            <td>
              <strong>
                CA INDOSUEZ (SWITZERLAND) SA HONG KONG BRANCH
              </strong>
            </td>
          </tr>
          <tr>
            <td>
              <strong>AZQORE</strong>
            </td>
            <td>
              AZQORE
              Data Protection Officer
              chemin de Bérée 38
              1010 Lausanne
            </td>
            <td>
              <a class="link" href="mailto:dpo@azqore.com">dpo@azqore.com</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralConditionFr'
}
</script>
